// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';

import { ImportazioneScrittureDto, ResultDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ImportazioneScrittureApiClient extends BaseCRUDApiClient<ImportazioneScrittureDto> {
  baseUrl = this.config.apiEndpoint + '/importazione-scritture';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  importScrittureExcelFile(file: File) {
    this._pagedCache.clear();
    const fd = new FormData();
    fd.append('file', file);
    return this.http.post<ResultDto>(
      this.baseUrl + '/import-scritture-excel',
      fd
    );
  }
}
